export var BUTTON_CLASS_PREFIX = 'Button';